export default __webpack_public_path__ + "static/NanumPenScript-Regular-0c455102368c5b02cf392c9b360998df.woff";